import request from '@/utils/request'
// import qs from 'qs'
/*
  管理台-设备管理 权限操作api
*/


/*
  综合柜 权限操作api
*/

// 根据筛选条件查询综合柜的列表信息
export function getCabinetList(data) {
  return request({
    url: 'device-service/cabinet/getCabinetList',
    method: 'get',
    params: data
  })
}

// 录入综合柜的基本信息
export function addCabinet(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'device-service/cabinet/addCabinet',
    method: 'post',
    data
  })
}

// 根据Excel文件模板批量录入综合柜设备信息
export function addCabinetsImport(fileData) {
  var data = new FormData();
  data.append("file", fileData);
  return request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: 'device-service/import/addCabinetsImport',
    method: 'post',
    data
  })
}

// 修改综合柜的基本信息
export function updateCabinet(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'device-service/cabinet/updateCabinet',
    method: 'put',
    data
  })
}

// 删除综合柜的基本信息和安装信息,及柜内设备
export function deleteCabinet(data) {
  const delData = {
    cabinetCode: data
  }
  return request({
    url: 'device-service/cabinet/deleteCabinet',
    method: 'delete',
    params: delData
  })
}

// 批量删除综合柜的基本信息和安装信息,及柜内设备
export function deleteCabinetList(data) {
  const delData = {
    cabinetCodes: data
  }
  return request({
    url: 'device-service/cabinet/deleteCabinetList',
    method: 'delete',
    params: delData
  })
}

// 根据cabinetCode查询该综合柜的柜内设备(已选择的设备)
export function getInsideDeviceByCabinetCode(data) {
  return request({
    url: 'device-service/cabinet/getInsideDeviceByCabinetCode',
    method: 'get',
    params: data
  })
}

// 根据deptId查询未选择的设备
export function getUnCheckDeviceByDeptId(data) {
  return request({
    url: 'device-service/cabinet/getUnCheckDeviceByDeptId',
    method: 'get',
    params: data
  })
}

// 录入综合柜柜内设备的关系
export function addCabinetInsideDevice(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'device-service/cabinet/addCabinetInsideDevice',
    method: 'post',
    data
  })
}

/*
  动环模块 权限操作api
*/

// 根据筛选条件查询综合柜柜内动环设备的列表信息
export function getMoveDeviceList(data) {
  return request({
    url: 'device-service/inside/getMoveDeviceList',
    method: 'get',
    params: data
  })
}

// 录入综合柜柜内动环设备的基本信息
export function addInsideMove(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'device-service/inside/addInsideMove',
    method: 'post',
    data
  })
}

// 修改综合柜的柜内动环设备信息
export function updateMoveDevice(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'device-service/inside/updateMoveDevice',
    method: 'put',
    data
  })
}

// 根据Excel文件模板批量录入柜内设备信息
export function addMovesImport(fileData) {
  var data = new FormData();
  data.append("file", fileData);
  return request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: 'device-service/import/addMovesImport',
    method: 'post',
    data
  })
}

// 录入oid信息
export function updateMoveOidImport(data) {
  var fileData = new FormData();

  fileData.append("file", data.file);
  fileData.append("moveCode", data.moveCode);
  return request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: 'device-service/import/updateMoveOidImport',
    method: "post",
    data: fileData,
  });
}

/*
  柜内设备 权限操作api
*/

// 根据筛选条件查询综合柜柜内设备的列表信息
export function getInsideDeviceList(data) {
  return request({
    url: 'device-service/inside/getInsideDeviceList',
    method: 'get',
    params: data
  })
}

// 录入综合柜柜内设备的基本信息
export function addInsideDevice(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'device-service/inside/addInsideDevice',
    method: 'post',
    data
  })
}

// 根据Excel文件模板批量录入柜内设备信息
export function addDevicesImport(fileData) {
  var data = new FormData();
  data.append("file", fileData);
  return request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: 'device-service/import/addDevicesImport',
    method: 'post',
    data
  })
}

// 修改综合柜的柜内设备信息
export function updateInsideDevice(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'device-service/inside/updateInsideDevice',
    method: 'put',
    data
  })
}

// 删除动环模块和柜内设备
export function deleteInsideCabinet(data) {
  const delData = {
    deviceCode: data
  }
  return request({
    url: 'device-service/inside/deleteCabinet',
    method: 'delete',
    params: delData
  })
}

// 批量删除动环模块和柜内设备
export function deleteInsideDeviceList(data) {
  const delData = {
    deviceCodes: data
  }
  return request({
    url: 'device-service/inside/deleteInsideDeviceList',
    method: 'delete',
    params: delData
  })
}